import axios from "axios";
const API_URL = process.env.REACT_APP_API_URL;
const Coupon_URL = `${API_URL}/coupon`;

const listCouponUsages = (data:any) => {
  return axios.post(`${Coupon_URL}/get-user-coupon-usage-list`,data).then((response) => {
    return response;
  });
};
const listCoupon = () => {
  return axios.get(`${Coupon_URL}/list`).then((response) => {
    return response;
  });
};


const createCoupon = (data: any) => {
  return axios.post(`${Coupon_URL}/add`, data).then((response) => {
    return response;
  });
};

const updateCoupon = (data: any, id: any) => {
  return axios.put(`${Coupon_URL}/edit/${id}`, data).then((response) => {
    return response;
  });
};
const viewCoupon = (id: any) => {
  return axios.get(`${Coupon_URL}/view/${id}`).then((response) => {
    return response.data;
  });
};


const deleteCoupon = (id: any, userId: number) => {
  return axios.put(`${Coupon_URL}/delete/${id}`, { userId }).then((response) => {
    return response.data;
  });
};


export { listCouponUsages , listCoupon, deleteCoupon, viewCoupon, createCoupon, updateCoupon };
